<template>
  <div class="container">
    <h1>Test Storefront</h1>
    <hr>
    <button class="btn btn-sm btn-primary" type="button" @click="openCustomerPortal()">
      Customer Portal
    </button>

<!--    <form method="POST" action="api/membership/stripe/create-customer-portal-session">-->
<!--      <button class="btn btn-sm btn-primary" type="submit">Customer Portal</button>-->
<!--    </form>-->

    <div v-for="product in products" :key="product.id">
      <div class="card product-card">
        <img :src="product.images[0]"><span class="product-title">{{product.name}}</span>
        <p>{{product.description}}</p>


        <div class="button-group">
          <div  v-for="price in product.prices" :key="price.id">
            <button class="btn btn-sm btn-primary" type="button" @click="buy(product, price)">
              ${{(price.unit_amount / 100).toFixed(2)}}{{price.recurring ? ` / ${price.recurring.interval}` : ''}}
            </button>
          </div>
        </div>

        <div class="api-response">
          <h5>api response</h5>
          <pre>{{JSON.stringify(product, null, 2)}}</pre>
        </div>
      </div>

      <p>
      </p>
    </div>
  </div>

  <GenericModal v-if="purchaseInfo" @modal-closed="purchaseInfo=null" class="purchase-modal">
    <template #header>
      {{purchaseInfo.productName}}
    </template>
    <StripePurchase :product_name="purchaseInfo.productName" :price_id="purchaseInfo.priceId" :is_subscription="purchaseInfo.isSubscription"></StripePurchase>
  </GenericModal>

</template>


<script>
import axios from "axios";
import GenericModal from "@/components/modal/GenericModal.vue";
import StripePurchase from "@/components/purchases/StripePurchase.vue";

export default {
  name: "AdminTestStorefront",
  components: {StripePurchase, GenericModal},
  data() {
    return {
      products: [],
      purchaseInfo: null,
    }
  },
  async created() {

    return axios.get(`/api/membership/stripe/products`)
        .then(response => {
          this.products = response.data;
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {

        });
  },

  methods: {
    buy(_product, _price) {

      this.purchaseInfo = {
        productName: _product.name,
        priceId: _price.id,
        isSubscription: !!_price.recurring
      };

      //console.log('buy()', this.purchaseInfo);
    },

    async openCustomerPortal() {
      axios.post('/api/membership/stripe/create-customer-portal-session', {
        return_url: '/admin'
      })
          .then(response => {
            window.location.href = response.data;
          })
          .catch(err => {
              console.log(err);
            });
    }
  }
}
</script>


<style scoped>

.product-card {
  padding: 1em;

  img {
    width: 50px;
    height: 50px;
  }

  .product-title {
    font-size: larger;
  }

  .button-group {
    position: absolute;
    top: 1em;
    right: 1em;

    button {
      float: right;
      margin: 5px;
    }


  }


  .api-response {
    color: grey;
    font-family: var(--bs-font-monospace);
    margin-top: 2em;

    pre {
      font-size: x-small;
      height: 20em;
      border-width: thin;
      border-style: solid;
      border-color: lightgrey;
      padding: 1em;

    }

  }
}


</style>